/* eslint-disable import/no-unresolved */
import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { urls } from '@auteco/constants';
import { Footer } from './styles';

const FooterComponent = () => (
    <>
      <Footer>
        <a href={urls.AUTECO_CONDITIONS}>Términos de uso</a>
        <a href={urls.AUTECO_HABEAS_DATA}>Política de datos</a>
        <Typography variant='body2' color='primary' align='center'>
          {'Copyright © '}
          <Link color='inherit' href={urls.AUTECO_HOME}>
            Auteco Mobility SAS
          </Link>
          {' '}
          {new Date().getFullYear()}
          .
        </Typography>
      </Footer>
    </>
  );

export default FooterComponent;
